import comp from "./Careers";
export default comp;
